// client/src/services/mysqlInstanceService.js
// Thin REST client for the MysqlInstance admin endpoints. Mirrors the pattern
// of alarmService.js so the UI code reads identically.

import { API_URL } from '../config.js';

function auth() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

async function j(res) {
  const data = await res.json();
  if (!data.success) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
}

const mysqlInstanceService = {
  async list() {
    const r = await fetch(`${API_URL}/admin/mysql-instances`, { headers: auth() });
    return (await j(r)).instances;
  },

  async get(instanceId) {
    const r = await fetch(`${API_URL}/admin/mysql-instances/${instanceId}`, { headers: auth() });
    return (await j(r)).instance;
  },

  async create(body) {
    const r = await fetch(`${API_URL}/admin/mysql-instances`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).instance;
  },

  async update(instanceId, body) {
    const r = await fetch(`${API_URL}/admin/mysql-instances/${instanceId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).instance;
  },

  async remove(instanceId) {
    const r = await fetch(`${API_URL}/admin/mysql-instances/${instanceId}`, {
      method: 'DELETE',
      headers: auth()
    });
    return j(r);
  },

  // Test-connection: server tries to acquire+ping; returns {ok:true} or details
  async test(instanceId, database) {
    const r = await fetch(`${API_URL}/admin/mysql-instances/${instanceId}/test`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify({ database })
    });
    // This endpoint can return success:false with ok:false — handle without throwing
    const data = await r.json();
    return data;
  }
};

export default mysqlInstanceService;
